<template>
    <div class="data-root">
        <Top></Top>
        <div class="data-body___1UbSf">
            <div class="side-menu-layout">
                <div class="content_menu">
                    <div class="menu___aQSZq">
                        <ul class="ant-menu kc-menu  ant-menu-light ant-menu-root ant-menu-inline">
                            <li class="ant-menu-item" :class="active == 'my' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/my','my')">
                                <a>{{ $t('m.my.nav[0]') }}</a>
                            </li>
                            <li class="ant-menu-item" :class="active == 'safe' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/safe','safe')">
                                <a>{{ $t('m.my.nav[1]') }}</a>
                            </li>
                            <li class="ant-menu-item" :class="active == 'realname' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/realname','realname')">
                                <a>{{ $t('m.my.nav[2]') }}</a>
                            </li>
                            <!--<li class="ant-menu-item" :class="active == 'information' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/information','information')">-->
                            <!--<a>基本资料</a>-->
                            <!--</li>-->
                            <li class="ant-menu-item" :class="active == 'api' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/api','api')">
                                <a>{{ $t('m.my.nav[3]') }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content_main">
                    <div class="ant-card ant-card-bordered ant-card-wider-padding ant-card-padding-transition">
                        <div class="ant-card-head">
                            <div class="ant-card-head-wrapper">
                                <div class="ant-card-head-title">基本资料</div>
                            </div>
                        </div>
                        <div class="ant-card-body" style="padding: 0;">
                            <div class="item___JkCtb">
                                <div>
                                    <span>头像</span>
                                    <span>
                                        <span class="ant-avatar  kc-avatar ant-avatar-circle ant-avatar-image" style="width: 64px; height: 64px; line-height: 64px; font-size: 18px;">
                                            <img src="@/assets/img/touxiang.svg" alt="">
                                        </span>
                                        <span class="ml-16">
                                            <span>
                                                <a>修改</a>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                                <div class="nicknameRow___1P2p6">
                                    <span>昵称</span>
                                    <div style="display: inline-block;">
                                        <span></span>
                                        <span>
                                            <a>设置</a>
                                        </span>
                                        <div class="nicknameTip___3wtuR">请注意，昵称每月只能改一次</div>
                                    </div>
                                </div>
                            </div>
                            <div class="item___JkCtb">
                                <div>
                                    <span>手机</span>
                                    <span>
                                        <span class="mr-8">**0790</span>
                                        <a>修改</a>
                                    </span>
                                </div>
                                <!--TODO-->
                                <div>
                                    <span>邮箱</span>
                                    <span>
                                        <span class="mr-8">12**@**.com</span>
                                        <a>修改</a>
                                    </span>
                                </div>
                            </div>
                            <div class="item___JkCtb">
                                <div>
                                    <span>时区</span>
                                    <span>
                                        <div class="kc-select  ant-select ant-select-enabled">
                                            <div class="ant-select-selection ant-select-selection--single" @click="timeShow = true">
                                                <div class="ant-select-selection__rendered">
                                                    <div class="ant-select-selection__placeholder" style="display: block; opacity: 1;">(UTC+8) 亚洲/新加坡</div>
                                                    <div class="ant-select-search ant-select-search--inline" style="display: none;">
                                                        <div class="ant-select-search__field__wrap">
                                                            <input type="text" class="ant-select-search__field">
                                                            <span class="ant-select-search__field__mirror"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="ant-select-arrow" style="user-select: none;">
                                                    <i class="ant-select-arrow-icon"></i>
                                                </span>
                                            </div>
                                            <div class="time-container" v-if="timeShow">
                                                <div class="time-list" @click="timeShow = false">(UTC+8) 亚洲/新加坡</div>
                                                <div class="time-list" @click="timeShow = false">(UTC+8) 亚洲/新加坡</div>
                                                <div class="time-list" @click="timeShow = false">(UTC+8) 亚洲/新加坡</div>
                                                <div class="time-list" @click="timeShow = false">(UTC+8) 亚洲/新加坡</div>
                                                <div class="time-list" @click="timeShow = false">(UTC+8) 亚洲/新加坡</div>
                                                <div class="time-list" @click="timeShow = false">(UTC+8) 亚洲/新加坡</div>
                                                <div class="time-list" @click="timeShow = false">(UTC+8) 亚洲/新加坡</div>
                                                <div class="time-list" @click="timeShow = false">(UTC+8) 亚洲/新加坡</div>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                <div>
                                    <span>汇率</span>
                                    <span>
                                        <div class="kc-select  ant-select ant-select-enabled">
                                            <div class="ant-select-selection ant-select-selection--single" @click="rateShow = true">
                                                <div class="ant-select-selection__rendered">
                                                    <div class="ant-select-selection__placeholder" style="display: block; opacity: 1;">USD</div>
                                                    <div class="ant-select-search ant-select-search--inline" style="display: none;">
                                                        <div class="ant-select-search__field__wrap">
                                                            <input type="text" class="ant-select-search__field">
                                                            <span class="ant-select-search__field__mirror"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="ant-select-arrow" style="user-select: none;">
                                                    <i class="ant-select-arrow-icon"></i>
                                                </span>
                                            </div>
                                            <div class="rate-container" v-if="rateShow">
                                                <div class="rate-list" @click="rateShow = false">USD</div>
                                                <div class="rate-list" @click="rateShow = false">USD</div>
                                                <div class="rate-list" @click="rateShow = false">USD</div>
                                                <div class="rate-list" @click="rateShow = false">USD</div>
                                                <div class="rate-list" @click="rateShow = false">USD</div>
                                                <div class="rate-list" @click="rateShow = false">USD</div>
                                                <div class="rate-list" @click="rateShow = false">USD</div>
                                                <div class="rate-list" @click="rateShow = false">USD</div>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                <div>
                                    <span>语言</span>
                                    <span>
                                        <div class="kc-select  ant-select ant-select-enabled">
                                            <div class="ant-select-selection ant-select-selection--single" @click="languageShow = true">
                                                <div class="ant-select-selection__rendered">
                                                    <div class="ant-select-selection__placeholder" style="display: block; opacity: 1;">中文简体</div>
                                                    <div class="ant-select-search ant-select-search--inline" style="display: none;">
                                                        <div class="ant-select-search__field__wrap">
                                                            <input type="text" class="ant-select-search__field">
                                                            <span class="ant-select-search__field__mirror"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="ant-select-arrow" style="user-select: none;">
                                                    <i class="ant-select-arrow-icon"></i>
                                                </span>
                                            </div>
                                            <div class="language-container" v-if="languageShow">
                                                <div class="language-list" @click="languageShow = false">中文简体</div>
                                                <div class="language-list" @click="languageShow = false">中文简体</div>
                                                <div class="language-list" @click="languageShow = false">中文简体</div>
                                                <div class="language-list" @click="languageShow = false">中文简体</div>
                                                <div class="language-list" @click="languageShow = false">中文简体</div>
                                                <div class="language-list" @click="languageShow = false">中文简体</div>
                                                <div class="language-list" @click="languageShow = false">中文简体</div>
                                                <div class="language-list" @click="languageShow = false">中文简体</div>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'

    export default {
        name: "information",
        components: {
            Top, Bottom
        },
        data() {
            return {
                active: 'information',
                timeShow: false,
                rateShow: false,
                languageShow: false
            }
        },
        methods: {
            changeTab: function (url, path) {
                this.active = path;
                this.changeRoute(url);
            }
        }
    }
</script>

<style scoped>
    @import "../../assets/css/information.css";
</style>
